(function ($) {
  window.DGS.Components = window.DGS.Components || {};
  window.DGS.Components.ImageSpot = window.DGS.Components.ImageSpot || {};
  window.DGS.Components.ImageSpot.ShouldEqualizeHeader = function ($spot) {
    return true;
  };
  window.DGS.Components.ImageSpot.ShouldEqualizeText = function ($spot) {
    return true;
  };
  window.DGS.OnLoad.getInstance().register(function () {
    $('.image-spot:not(.accordion):not(.as-slider)').each(function () {
      if (window.DGS.Components.ImageSpot.ShouldEqualizeHeader($(this))) {
        window.DGS.EqualHeight.getInstance().register($('.image-spot-element-header', $(this)));
      }
      if (window.DGS.Components.ImageSpot.ShouldEqualizeText($(this))) {
        window.DGS.EqualHeight.getInstance().register($('.image-spot-element-text', $(this)));
      }
    });
    window.DGS.EqualHeight.getInstance().register($('.image-spot-element-header', $(this)));
    window.DGS.EqualHeight.getInstance().register($('.image-spot-element-text', $(this)));
    function onAddContentClick(event, data) {
      var $this = $(this),
        $ul = $this.closest('ul'),
        $lis = $('.image-spot-element', $ul),
        $li = $this.closest('.image-spot-element'),
        liIndex = $li.index(),
        index = $li.data('context-content-index'),
        division = $li.data('context-content-division'),
        $contentlist = $('.image-spot-element-context', $ul),
        $content = $('.image-spot-element-context', $li),
        divisionWidth = 100 / division,
        selectorleft = divisionWidth * liIndex + divisionWidth / 2,
        $componentContent = $this.closest('.component-content'),
        $container = $('.context-container', $componentContent),
        isStacked = $lis.length == 1,
        $prevLi;
      event.preventDefault();
      if ($content) {
        $lis.each(function () {
          var $this = $(this);
          if ($prevLi != null) {
            if ($this.offset().top > $prevLi.offset().top) {
              isStacked = true;
            }
          }
          $prevLi = $this;
        });
        if (!$container.length) {
          $container = $('<div class="context-container"></div>');
          $componentContent.append($container);
        }
        $lis.removeClass('active');
        if (!isStacked) {
          if ($container.data('context-content-index') != index) {
            $container.slideUp(0, function () {
              $li.addClass('active');
              $container.html($content.children().clone(true));
              // get selectors border width
              var sbw = parseFloat($('.image-spot-element-context-selector', $container).css('border-left-width')),
                // get active li's padding-left and padding-right
                apl = parseFloat($li.css('padding-left')) / 2,
                apr = parseFloat($li.css('padding-right')) / 2,
                // get context-container width
                ccw = $container.outerWidth(),
                // calculate percent
                percent = (selectorleft / 100 * ccw - sbw + apl - apr) / ccw;
              $('.image-spot-element-context-selector', $container).css('left', "".concat(percent * 100, "%"));
              if (data != null && !data.animate) {
                $container.show();
              } else {
                $container.slideDown(0);
              }
            });
            $container.data('context-content-index', index);
          } else {
            $container.slideUp(0);
            $container.data('context-content-index', '-1');
          }
        } else {
          if ($container.data('context-content-index') != index) {
            $container.css('display', 'block');
            $container.data('context-content-index', index);
            $li.addClass('active');
          } else {
            $container.css('display', 'none');
            $container.data('context-content-index', '-1');
          }
          $container.html($content.children().clone(true));
          $contentlist.each(function () {
            if (this != $content[0]) {
              $(this).hide('fast');
            } else {
              $content.slideToggle('slow');
            }
          });
          $('.image-spot-element-context-selector', $container).css('left', "".concat(selectorleft, "%"));
        }
        //                $('.image-spot-element-context-selector', $content).css('left', '50%');
      }
    }
    $('.image-spot:not(.accordion)').each(function () {
      var $imageSpot = $(this),
        index = 0,
        numLi = $('.image-spot-element', $imageSpot).length;
      $('.image-spot-element', $imageSpot).each(function () {
        var $this = $(this),
          $link = $('.image-spot-element-link a', $this),
          href = $link.attr('href'),
          target = $link.attr('target'),
          title = $link.attr('title') != undefined ? $link.attr('title') : '',
          $context = $('.image-spot-element-context', $this),
          $image = $('.image-spot-element-image', $(this));
        if ($context.length) {
          href = '#';
          $link.attr('href', href);
          $this.data('context-content-index', index);
          $this.data('context-content-division', numLi);
          $image.wrap("<a href=\"".concat(href, "\"></a>"));
          $image.parent().on('click', onAddContentClick);
          $link.on('click', onAddContentClick);
        } else if (href != undefined && href != '') {
          $image.wrap("<a href=\"".concat(href, "\" target=\"").concat(target, "\" title=\"").concat(title.replace(/\</g, '[').replace(/\>/g, ']').replace(/"/g, "'"), "\"></a>"));
        }
        index++;
      });
    });
    $('.component.image-spot.accordion .image-spot-element').each(function () {
      var $this = $(this),
        $header = $('.image-spot-element-header', $this),
        $image = $('.image-spot-element-image', $this),
        $text = $('.image-spot-element-text', $this),
        $contentWrapper = $('<div class="image-spot-element-content"></div>');
      $contentWrapper.insertAfter($header);
      $contentWrapper.append($('<div class="spacer"></div>'));
      $contentWrapper.append($image);
      $contentWrapper.append($text);
      $contentWrapper.append($('<div class="mask"></div>'));
      $header.click(function () {
        var openThis = true;
        if ($this.hasClass('open')) {
          openThis = false;
        }
        $('.component.image-spot.accordion .image-spot-element').removeClass('open');
        if (openThis) $this.addClass('open');
      });
    });
    window.DGS.Resizer.getInstance().register(function () {
      $('.image-spot').each(function () {
        var $this = $(this),
          $activeLi = $('li.active', $this),
          $content = $('.image-spot-element-context', $activeLi);
        if ($content.length) {
          $content.show();
        }
      });
      $('.image-spot.accordion .image-spot-element').each(function () {
        var $this = $(this),
          $container = $('.image-spot-element-content', $this),
          $spacer = $('.spacer', $this),
          $img = $('.image-spot-element-image', $this),
          $header = $('.image-spot-element-header', $this),
          $text = $('.image-spot-element-text', $this),
          h;
        $container.outerWidth($header.outerWidth());
        $spacer.height(0);
        h = Math.max(0, $container.outerHeight() - $img.outerHeight());
        $spacer.height(h);
        while (h > 0 && $img[0].getBoundingClientRect().bottom > $text[0].getBoundingClientRect().bottom + 16) {
          $spacer.height(--h);
        }
        if ($('img', $img).length < 1) {
          $img.hide();
        }
      });
    });
  });
})(jQuery);